import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

export const StyledTabs = withStyles((theme) => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    width: '100%',
    padding: 10,

    borderBottom: '5px solid #0C6AB6',

  },
}))((props) => <Tabs {...props} />);

export const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    color: '#000',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    margin: theme.spacing(1, 0),
    '&:focus': {
      opacity: 1,
    },
    width: '100%',
    whiteSpace: 'noWrap',
    [theme.breakpoints.down('xs')]: {
      width: 150,
      lineHeight: '20px',
      whiteSpace: 'normal',
    },

  },
}))((props) => <Tab {...props} />);

export const styles = theme => ({
  tab: {
    fontFamily: theme.typography.fontKanit,
    opacity: 1,
    fontSize: 16,
    fontWeight: 500,
    color: '#000',
    '&:nth-of-type(even)': {
      borderRight: '1px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
    border: '1px solid #ccc',

    // maxWidth: '-webkit-fill-available',
    maxWidth: 'inherit',
  },
  active_tab: {
    color: 'white',
    fontSize: 16,
    fontFamily: theme.typography.fontKanit,
    backgroundColor: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 500,
    borderBottom: '1px solid #ccc',
    [theme.breakpoints.down('xs')]: {
      // width: 200,
    },
    // maxWidth: '-webkit-fill-available',
    maxWidth: 'inherit',
  },
  contentImg: {
    padding: theme.spacing(3),

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0),
    },
  },
  container: {
    maxHeight: 506,
  },
  icon: {
    padding: theme.spacing(0),
  },
  titleSub: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 14,
    fontWeight: 500,
    paddingTop: theme.spacing(3),
  },
  titleBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 19,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(1),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  titleSecondBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 16,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '100%',
    padding: theme.spacing(1),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  titleThirdBox: {
    fontFamily: theme.typography.fontKanit,
    fontSize: 16,
    fontWeight: 400,
    background: theme.palette.background.grey,
    textAlign: 'center',
    width: '30%',
    padding: theme.spacing(1),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  bodyBox: {
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.line.main}`,
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    align: 'center',
  },
  bodyTmdBox: {
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.line.main}`,
    borderRadius: 6,
  },
  bodyAnimationBox: {
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.line.main}`,
  },
  tabStyle: {
    marginTop: theme.spacing(3),
    background: 'transparent',
    boxShadow: 'none',
  },
  tabModal: {
    width: '100%',
    fontFamily: theme.typography.fontKanit,
    fontSize: 12,
    marginTop: theme.spacing(0),
    background: 'transparent',
    boxShadow: 'none',
  },
  paperModal: {
    position: 'absolute',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    outline: 'none',
  },
  responsive: {
    width: '100%',
    height: '100%',
  },
  img: {
    width: '100%',
  },

});